import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserProfileService } from '../Services/user-profile/user-profile.service';
import { UserProfile } from '../Services/user-profile/UserProfile';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {
  constructor(
    private router: Router,
    private userProfileService: UserProfileService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this
      .userProfileService
      .userProfileObservable()
      .pipe(
        map((user: UserProfile|null) => {
          if (!user) {
            this.saveRouteToRedirect();
            this.router.navigateByUrl('/login');
            return false;
          }

          let redirectRoute = this.getRedirectRoute();
          if(redirectRoute) this.router.navigateByUrl(redirectRoute);
          return true;
        })
      );
  }

  saveRouteToRedirect(){
    sessionStorage.setItem('redirectUrl', location.pathname);
  }

  getRedirectRoute(){
    let url = sessionStorage.getItem('redirectUrl');
    sessionStorage.removeItem('redirectUrl');
    return url;
  }

}
